document.addEventListener('DOMContentLoaded', init);
document.addEventListener('turbo:load', init);

function init() {
    // ===== Mobile hamburger (drives the checkbox so it works w/ or w/o JS) =====
    var mobileToggle = document.getElementById('mobileToggle');
    var burger1 = document.getElementById('hamburger-1');
    var burger2 = document.getElementById('hamburger-2');
    var burger3 = document.getElementById('hamburger-3');
    var x1 = document.getElementById('close-x-1');
    var x2 = document.getElementById('close-x-2');

    // When the checkbox changes (clicked via the <label>), update the icon
    if (mobileToggle) {
        mobileToggle.addEventListener('change', function () {
            var open = mobileToggle.checked;
            if (burger1 && burger2 && burger3 && x1 && x2) {
                burger1.classList.toggle('hidden', open);
                burger2.classList.toggle('hidden', open);
                burger3.classList.toggle('hidden', open);
                x1.classList.toggle('hidden', !open);
                x2.classList.toggle('hidden', !open);
            }
        });
    }

    // ===== Desktop partners dropdown (scoped) =====
    var btn = document.getElementById('nav_desktop_partners_btn');
    if (btn) {
        var panel = btn.parentElement && btn.parentElement.querySelector('.dropdown-panel');
        if (panel) {
            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                var expanded = btn.getAttribute('aria-expanded') === 'true';
                btn.setAttribute('aria-expanded', String(!expanded));
                panel.classList.toggle('hidden', expanded);
            });
            document.addEventListener('click', function () {
                btn.setAttribute('aria-expanded', 'false');
                panel.classList.add('hidden');
            });
        }
    }

    // ===== Mobile partners submenu (enhance checkbox with ARIA + caret rotation) =====
    var partnersToggle = document.getElementById('mobilePartnersToggle');
    var caret = document.getElementById('mobilePartnersCaret');
    if (partnersToggle) {
        partnersToggle.addEventListener('change', function () {
            var open = partnersToggle.checked;
            var trigger = document.getElementById('nav_mobile_partners_btn');
            if (trigger) trigger.setAttribute('aria-expanded', String(open));
            if (caret) caret.classList.toggle('rotate-90', open);
        });
    }
}